import {SCDOptionsType} from 'common/widgets/property-filter-menu/models/types';
import {InsightsBookmarkParams} from 'common/types/reports/bookmark';

import {isBehaviorShowClause} from '../models/utils';
import {BehaviorShowClause, ShowClause} from './types';

export function hasSCDOptionsType(type: SCDOptionsType, bookmark: InsightsBookmarkParams) {
  return (
    bookmark.sections.show.some(
      (show) =>
        // TODO - go/j/AE-796: Replace these with Pydantic-generated counterparts once fully defined and remove typecasts
        isBehaviorShowClause(show as ShowClause) &&
        (show as BehaviorShowClause).behavior?.filters?.some((filter) => filter.scdOptions?.type === type),
    ) ||
    bookmark.sections.filter?.some((filter) => filter.scdOptions?.type === type) ||
    bookmark.sections.group?.some((group) => group.scdOptions?.type === type)
  );
}
